import {CommonService} from '../../../shared/utils/common.service';
import {UtilsService} from '../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {moduloRPlus} from '../diccionarios/RPlusModulo.js';

@Injectable({
  providedIn: 'root'
})
export class RPlusService {

  private diccionarioModulo: any;
  private url: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloRPlus;
    this.url = this._util.geturlRPlus();
    //this.url = "http://localhost:8080/rplus-api/v1/api/service";
  }

  getAll(date: string): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.consultaDeProcesos.obtenerTodo + date
    );
  }

  onDemand(): Observable<any> {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.ejecucionDeProcesos.onDemand,
      {
        'user': localStorage.getItem('userName'),
        "id": 0
      }
    );
  }

  demandAll(payload): Observable<any> {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.ejecucionDeProcesos.demandAll,
      payload
    );
  }

  partes(): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ejecucionDeProcesos.partes + "?user=" + localStorage.getItem('userName')
    );
  }

  inventario(): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ejecucionDeProcesos.inventario + "?user=" + localStorage.getItem('userName')
    );
  }

  demandas(): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ejecucionDeProcesos.demandas + "?user=" + localStorage.getItem('userName')
    );
  }

  supply(): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ejecucionDeProcesos.supply + "?user=" + localStorage.getItem('userName')
    );
  }

  formulas(): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ejecucionDeProcesos.formulas + "?user=" + localStorage.getItem('userName')
    );
  }

  consumos(): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ejecucionDeProcesos.consumos + "?user=" + localStorage.getItem('userName')
    );
  }

  import(): Observable<any> {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.ejecucionDeProcesos.import,
      {
        "option": "string",
        "ignoreSourceERP": true,
        'user': localStorage.getItem('userName'),
      }
    );
  }

  // T.14473 CPD Forzado
  getAllParametros(): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.parametros.path
    );
  }

  getAllParametrosActivos(): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.parametros.path + "/activos"
    );
  }

  createParametros(request): Observable<any> {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.parametros.path, request);
  }

  deleteParametros(request): Observable<any> {
    return this._commom.peticionDeleteConHeader(
      this.url + this.diccionarioModulo.url.parametros.path, request);
  }

  updateParametros(request): Observable<any> {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.parametros.path, request);
  }

}
